import { CampaignId } from '@shared/types/campaign.ts';

export const apiRoutes = {
  getAdvertisers: () => `/advertisers`,
  getBrands: (advertiserId: string) => `/advertisers/${advertiserId}/brands`,
  getContentPackages: () => `/content-packages`,
  getAgeAndGenderGroups: () => `/age-gender`,
  getInterestSegments: () => `/interest-segments`,
  getGeoData: () => `/geo-data`,
  createCampaign: () => `/campaigns`,
  readCampaign: (campaignId: CampaignId) => `/campaigns/${campaignId}`,
  updateCampaignStep01: (campaignId: CampaignId) => `/campaigns/${campaignId}/details`,
  updateCampaignCTVDisplayAdProducts: (campaignId: CampaignId) => `/campaigns/ctv/${campaignId}/ad-products/display`,
  updateCampaignCTVVideoAdProducts: (campaignId: CampaignId) => `/campaigns/ctv/${campaignId}/ad-products/video`,
  updateCampaignCrossAdProducts: (campaignId: CampaignId) => `/campaigns/cross/${campaignId}/ad-products`,
  updateCampaignStep04: (campaignId: CampaignId) => `/campaigns/${campaignId}/additional-note`,
  updateCampaignCTVTargeting: (campaignId: CampaignId) => `/campaigns/ctv/${campaignId}/targeting`,
  updateCampaignCrossTargeting: (campaignId: CampaignId) => `/campaigns/cross/${campaignId}/targeting`,
  updateCampaignThematicTargeting: (campaignId: CampaignId) => `/campaigns/thematic/${campaignId}/targeting`,
  creativeLShapeImage: (campaignId: CampaignId) => `/campaigns/${campaignId}/l-shape-image`,
  creativeLandingImage: (campaignId: CampaignId) => `/campaigns/${campaignId}/landing-image`,
  creativeSwitchInLeftImage: (campaignId: CampaignId) => `/campaigns/${campaignId}/left-l-shape-image`,
  creativeSwitchInBottomImage: (campaignId: CampaignId) => `/campaigns/${campaignId}/bottom-l-shape-image`,
  updateHighImpactAdProduct: (campaignId: CampaignId) => `/campaigns/thematic/${campaignId}/ad-products/high-impact`,
  creativeIntroMobileImage: (campaignId: CampaignId) => `/campaigns/thematic/${campaignId}/intro-mobile-image`,
  creativeMastheadImage: (campaignId: CampaignId) => `/campaigns/thematic/${campaignId}/masthead-image`,
  creativeMastheadAdaptiveImage: (campaignId: CampaignId) =>
    `/campaigns/thematic/${campaignId}/masthead-adaptive-image`,
  creativeSkinImage: (campaignId: CampaignId) => `/campaigns/thematic/${campaignId}/skin-image`,
  creativeVideoUploadParams: (campaignId: CampaignId) => `/campaigns/${campaignId}/video-creative-upload-params`,
  creativeVideoSpot: (campaignId: CampaignId) => `/campaigns/${campaignId}/video-creative`,
  submitCampaign: (campaignId: CampaignId) => `/campaigns/${campaignId}/submit`,
  readPricing: (campaignId: CampaignId) => `/campaigns/${campaignId}/pricing`,
  updatePricing: (campaignId: CampaignId) => `/campaigns/${campaignId}/pricing`,
  getBillingContacts: (advertiserId: string) => `/advertisers/${advertiserId}/billing-contacts`,
  updateBillingDetails: (campaignId: CampaignId) => `/campaigns/${campaignId}/billing-details`,
};
